export const APP_CONFIG = {
  maxCollectionSize: 1000000,
  startingMoney: 20.00,
  freePackInterval: 6 * 60 * 60 * 1000
  // freePackInterval: 30000  // For testing purposes
};
